import {URL_API_SAMPLING_TEMPLATES, URL_API_SAMPLING_TEMPLATES_ADD, URL_API_SAMPLING_TEMPLATES_EDIT, 
  URL_API_SAMPLING_TEMPLATES_MAPPING, URL_API_SAMPLING_TEMPLATES_MAPPEDLIST, URL_API_SAMPLING_DEFAULT_TEMPLATES,
  URL_API_SAMPLING_TEMPLATES_CALLMIX, URL_API_SAMPLING_TEMPLATES_MAPPING_UPDATE} from '../apiHitFile';
import _ from 'lodash';

export function SamplingDefaultTemplate(){
  return (dispatch, getState) => {  
    fetch(URL_API_SAMPLING_DEFAULT_TEMPLATES, {
      method: 'GET',
      headers : new Headers(),
    })
     .then(res=>res.json())
     .then(json => dispatch(SamplingDefaultTemplateSuceess(json)))
     .catch(error => console.log(error))
    } 
}
export function SamplingDefaultTemplateSuceess(data){
  return{
      type: 'SAMPLING_TEMPLATE_DEFAULT',
      default: data.value
    }
}

export function SamplingMappedListAction(){ 
  return (dispatch, getState) => {
    let headers = new Headers()
    fetch(URL_API_SAMPLING_TEMPLATES_MAPPEDLIST, {
      method: 'GET',
      headers : headers,
    })
     .then(res=>res.json())
     .then(json => dispatch(SamplingMappedListActionSuceess(json)))
     .catch((error) =>  dispatch(SamplingError(error))) 
    }   
}   
export function SamplingMappedListActionSuceess(mappedList){
  return{
    type: 'SAMPLING_MAPPED_LIST_ACTION',
    mappedData: mappedList.value
  } 
}

export function SamplingDurationAction(){ 
  return (dispatch, getState) => {
    let headers = new Headers()
    return fetch(URL_API_SAMPLING_TEMPLATES_CALLMIX, {
      method: 'GET',
      headers : headers,
    })
     .then(res=>res.json())
     .then(json => dispatch(SamplingDurationSuceess(json))) 
     .catch((error) =>  dispatch(SamplingError(error)))     
    };  
  
}
export function SamplingDurationSuceess(Duration){
  return{
    type: 'SAMPLING_DURATION_ACTION',
    duration: Duration.value
   } 
}

export function SamplingTemplateAction(){
  return (dispatch, getState) => {
    let headers = new Headers()
    fetch(URL_API_SAMPLING_TEMPLATES, {
      method: 'GET',
      headers : headers,
    })
     .then(res=>res.json())
     .then(json => dispatch(SamplingTemplateActionSuceess(json)))
     .catch((error) =>  dispatch(SamplingError(error)))
    }   
}

export function SamplingTemplateActionSuceess (data){
  return{
    type: 'SAMPLING_TEMPLATE_ACTION',
    payload: data.value
   }
}
export function SamplingTemplateAdd(prop){
  return (dispatch, getState) => {
    let headers = new Headers()    
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_SAMPLING_TEMPLATES_ADD, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res.json())  
      .then(json => {dispatch(SamplingTemplateAddSuceess(json, prop))       
        dispatch(SamplingTemplateAction())
        dispatch(SamplingError(json))
        })
      .catch((error) =>  dispatch(SamplingError(error)))
  }
}
export function SamplingTemplateAddSuceess(json, prop){
  if(!_.isEmpty(json.value)){
  return{
    type: 'SAMPLING_TEMPLATE_ADD',
    prop
  }
 } else {
  return {
    type:'SAMPLING_ERROR',
    showerror:true,
    errmessage:json.message
  }
 }
}

export function SamplingTemplateEdit(title, newtemplate){ 
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_SAMPLING_TEMPLATES_EDIT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(newtemplate)
    }).then((res) => res.json())
      .then(json =>{dispatch(SamplingTemplateEditSuccess(title, newtemplate))
       dispatch(SamplingError(json)) })
      .catch((error) =>  dispatch(SamplingError(error)))
  }    
}
export function SamplingTemplateEditSuccess(title, newtemplate){
  return{
    type: 'SAMPLING_TEMPLATE_EDIT',
    title, newtemplate
  }
}

export function SamplingTemplateMapping(obj){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_SAMPLING_TEMPLATES_MAPPING, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then(json => {dispatch(SamplingTemplateMappingSuccess(json))
      })
      .catch((error) =>  dispatch(SamplingError(error)))
  } 
}
export function SamplingTemplateMappingSuccess(message){
  if(message.status === 1001){
  return{
    type: 'SAMPLING_TEMPLATE_MAPPING',
    mapstatus: message.status,
    mapmessage: message.message
    }
  } else {
    return{
      type:'SAMPLING_ERROR',
      showerror:true,
      errmessage:message.message
    }
  }
}
export function SamplingTemplateReAssign(obj){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_SAMPLING_TEMPLATES_MAPPING, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then(json => {
        dispatch(SamplingTemplateUpdateMapping())
      })
      .catch((error) =>  dispatch(SamplingError(error)))
  } 
}
export function SamplingTemplateUpdateMapping(){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_SAMPLING_TEMPLATES_MAPPING_UPDATE, {
      method: 'GET',
      headers : headers,
    }).then((res) => res.json())
      .then(json => {
        if(json.status === 1001){
          dispatch({type:'SAMPLING_ERROR', showerror:true, errmessage:json.message})
          dispatch(SamplingMappedListAction())
        }
      })
      .catch((error) =>  {dispatch({type:'SAMPLING_ERROR', showerror:true, errmessage:error.message})})
    }
}

export function SamplingError(error){
  return{
    type:'SAMPLING_ERROR',
    showerror:true,
    errmessage:error.message
  }
}
export function closeModalPopUp(){
  return{
    type:'SAMPLING_MODAL_CLOSE',
    showerror:false
  }

}

